import IDatasetLayoutStrategy from './IDatasetLayoutStrategy';
import DatasetsLayoutNode from './layout/DatasetsLayoutNode';
import HorizontalStackLayoutNode from './layout/HorizontalStackLayoutNode';
import SingleDatasetLayoutNode from './layout/SingleDatasetLayoutNode';
import TabsLayoutNode from './layout/TabsLayoutNode';
import VerticalStackLayoutNode from './layout/VerticalStackLayoutNode';
import DatasetTreeNode from './logical/DatasetTreeNode';

/**
 * Implementation of {@link IDatasetLayoutStrategy} for display modes.
 */
class DatasetLayoutStrategy implements IDatasetLayoutStrategy {
  public doLayout(dataset: DatasetTreeNode): DatasetsLayoutNode {
    return this.doLayoutImpl(dataset, false);
  }

  private doLayoutImpl(
    dataset: DatasetTreeNode,
    needsRootTab: boolean
  ): DatasetsLayoutNode {
    let node: DatasetsLayoutNode = new SingleDatasetLayoutNode(dataset);

    if (needsRootTab) {
      const tabs = new TabsLayoutNode();
      tabs.addChild(node);
      node = tabs;
    }

    if (!dataset.hasChildren()) {
      return node;
    }

    const vstack = new VerticalStackLayoutNode();
    vstack.addChild(node);

    const details = dataset.getChildrenCopy();

    details.sort((first, second) => first.getGroup() - second.getGroup());

    const groups: DatasetsLayoutNode[] = [];
    const groupsNodes: Record<number, DatasetTreeNode[]> = {};
    let lastGroupId: number | null = null;

    for (const detail of details) {
      const groupId = detail.getGroup();
      if (groupId !== lastGroupId) {
        lastGroupId = groupId;
        groupsNodes[groupId] = [detail];
      } else {
        groupsNodes[groupId].push(detail);
      }
    }

    for (const group in groupsNodes) {
      if (groupsNodes[group].length > 1) {
        const tabs = new TabsLayoutNode();
        for (const detail of groupsNodes[group]) {
          tabs.addChild(this.doLayoutImpl(detail, false));
        }
        groups.push(tabs);
      } else {
        groups.push(this.doLayoutImpl(groupsNodes[group][0], false));
      }
    }

    if (groups.length > 1) {
      const hstack = new HorizontalStackLayoutNode();

      for (const group of groups) {
        hstack.addChild(group);
      }

      vstack.addChild(hstack);
    } else {
      vstack.addChild(groups[0]);
    }

    return vstack;
  }
}

export default DatasetLayoutStrategy;
